import { DocumentListSection } from "../../../../../components/Proposal&Contracts/DocumentListSection.tsx"

export const defaultExclusions = [
  "Finish materials such as tiles, fixtures, appliances, cabinets, flooring, paint.",
  "Permit fees, design fees, or architectural drawings."
]

export function ProposalExclusionsSection() {
  return (
    <DocumentListSection
      title="Exclusions"
      name="exclusions"
      // defaultItems={defaultExclusions}
      // infoFieldName={["exclusionsInfo"]}
      // infoPlaceholder="This proposal does not include (unless specifically noted):"
      itemPlaceholder="Exclusion item"
      addButtonText="Exclusion"
    />
  )
}
